var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["slider", "slider--controls-" + this.controlsPlacement] },
    [
      _c(
        "div",
        { ref: "slider", staticClass: "swiper-container slider__container" },
        [_c("div", { staticClass: "swiper-wrapper" }, [_vm._t("default")], 2)]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "slider__wrapper" }, [
        this.$slots.default && this.$slots.default.length > 1
          ? _c("div", { staticClass: "slider__controls" }, [
              _vm.buttons
                ? _c(
                    "button",
                    {
                      ref: "prev",
                      staticClass: "slider__nav-btn slider__nav-btn--prev",
                    },
                    [
                      _c("z-icon", {
                        attrs: { name: "arrow_bold", dir: "left" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pagination
                ? _c("div", {
                    ref: "pagination",
                    staticClass: "slider__pagination",
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.buttons
                ? _c(
                    "button",
                    {
                      ref: "next",
                      staticClass: "slider__nav-btn slider__nav-btn--next",
                    },
                    [
                      _c("z-icon", {
                        attrs: { name: "arrow_bold", dir: "right" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }